import React from "react";
import '../customcss.css'

export default function Works() {
  return (
    <section>
      <div className="container h-100 mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <p>"This is from Works page"</p>
      </div>
    </section>
  );
}
